import { defineFcm } from '../shared/factory';

export const FCM_GROWTH_BONUS_IMPRESSION_VALUE_UI = defineFcm('growth_bonus_impression_value_ui')
	.asBoolean()
	.withDefault(false)
	.toConfig();
